import { Alert } from '@mui/material';
import { useState } from 'react';
import { useUA } from 'use-ua-parser-js';

export const UnsupportedBrowserWarning = () => {
  const ua = useUA();
  const isChrome = ua?.browser?.name === 'Chrome';
  const [isOpen, setIsOpen] = useState(!isChrome);

  const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsOpen(false);
  };

  return (
    isOpen && (
      <Alert onClose={handleClose} severity='warning'>
        You are using an unsupported browser. Please use Google Chrome for the
        best experience.
      </Alert>
    )
  );
};
